module.exports = __webpack_public_path__ + "front/img/bg06.ce2ec6c9.png";